import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, UserCheck, Coffee, DollarSign, MessageCircleHeart } from 'lucide-react';
import { Card } from './ui/Card';
const values = [{
  icon: DollarSign,
  title: 'Maximize Your Refund',
  description: 'Professional review to capture every credit and deduction available to you.'
}, {
  icon: UserCheck,
  title: 'Prepared by a CPA or EA',
  description: 'Your return is completed by a licensed expert, ensuring 100% accuracy.'
}, {
  icon: Coffee,
  title: 'Stress-Free Filing',
  description: 'We handle everything from start to finish. Sit back and relax.'
}, {
  icon: ShieldCheck,
  title: 'Simple Pricing',
  description: 'Flat rate starting at $250. No hidden fees or surprises.'
}, {
  icon: MessageCircleHeart,
  title: 'Personalized Service',
  description: 'Clear communication, friendly support, and fast turnaround times.'
}];
export function ValueSection() {
  return <section id="value-section" className="py-24 bg-white relative" data-id="element-185">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-186">
        <div className="text-center mb-16" data-id="element-187">
          <h2 className="text-3xl md:text-4xl font-bold text-primary-dark mb-4" data-id="element-188">
            Why Choose Coastal Ember?
          </h2>
          <p className="text-lg text-neutral-600 max-w-2xl mx-auto" data-id="element-189">
            We bring a breath of fresh air to tax season with a service designed
            around your life.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-190">
          {values.map((value, index) => <Card key={index} className="p-8 h-full border-t-4 border-t-secondary" hoverEffect={true} data-id="element-191">
              <div className="w-12 h-12 bg-secondary-light/30 rounded-xl flex items-center justify-center mb-6 text-secondary-dark" data-id="element-192">
                <value.icon className="w-6 h-6" data-id="element-193" />
              </div>
              <h3 className="text-xl font-bold text-neutral-800 mb-3" data-id="element-194">
                {value.title}
              </h3>
              <p className="text-neutral-600 leading-relaxed" data-id="element-195">
                {value.description}
              </p>
            </Card>)}
        </div>
      </div>
    </section>;
}